import { render, staticRenderFns } from "./createAi.vue?vue&type=template&id=daae9310&scoped=true"
import script from "./createAi.vue?vue&type=script&lang=js"
export * from "./createAi.vue?vue&type=script&lang=js"
import style0 from "./createAi.vue?vue&type=style&index=0&id=daae9310&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daae9310",
  null
  
)

export default component.exports